import React from 'react'
import styled from 'styled-components'
import media from '../../../styles/media'

const ContactWrapper = styled.div`
  font-family: Raleway;
  font-size: 14px;
  font-weight: normal;
  font-style: normal;
  font-stretch: normal;
  line-height: 1.29;
  letter-spacing: normal;
  text-align: left;
  color: #ffffff;
  & a {
    color: #ffffff;
    text-decoration: none;
  }
`
const StyledIcon = styled.i`
  color: #40b4e4;
`

const StyledSpan = styled.span`
  a {
    text-decoration: underline;
  }
`

const Contact = props => {
  let { toggleContact, contactIsOpen } = props
  return (
    <ContactWrapper className="container">
      <div className="row">
        <div className="col-12 col-md mr-auto text-center text-md-left my-4">
          <StyledSpan>
            <a
              href="/docs/Politica_de_Proteccion_de_datos-PPM.pdf"
              target="_blank"
            >
              Política de privacidad
            </a>{' '}
            | &nbsp;
            <a href="/docs/Politica_de_Cookies-PPM.pdf" target="_blank">
              Política de Cookies
            </a>
          </StyledSpan>
        </div>
        <div className="col-12 col-md-auto text-center my-auto">
          <a href="tel:+59323956060">
            <StyledIcon className="icon-phone" />
            +593 2 395 6060
          </a>
        </div>
        <div className="col-12 col-md-auto text-center my-4">
          <a href="mailto:info@ppm.com.ec">
            <StyledIcon className="icon-mail-line" />
            info@ppm.com.ec
          </a>
        </div>
      </div>
    </ContactWrapper>
  )
}

export default Contact



// WEBPACK FOOTER //
// ./src/components/footer/contact/contact.js